/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
import{strict as r}from"../../../core/jsonMap.js";const c=r()({barchart:"bar-chart",columnchart:"column-chart",linechart:"line-chart",piechart:"pie-chart"});export{c as chartTypeKebabDict};
